import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, WorkRole, WorkType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'code-service-picker',
    templateUrl: './code.service.picker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: CodeServicePickerComponent, multi: true }
    ],
    standalone: false
})
export class CodeServicePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Code Service>';
  @Input() public appendTo;
  @Input() public multiple: boolean;

  public data$: Observable<Entity[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
    this.hideSelected = true;
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getWorkRoles()
      : of(this.data);

  }

  private getWorkRoles(): Observable<WorkRole[]> {
    return this.http.get<WorkRole[]>('/api/picker/code/services');
  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    CodeServicePickerComponent
  ],
  providers: [],
  exports: [
    CodeServicePickerComponent
  ],
})
export class CodeServicePickerModule { }
